import React, { memo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectorQuiz } from '../../features/quiz/quizSlice.js'
import questionnaire from '../../questionnaire.js'

/**
 * NAV QUIZ COMPONENT
 * @param {{ totalSteps: number, currentStep: number, goToStep: (i: number) => void }} props 
 * @returns {JSX.Element}
 */
function SubNavQuiz({totalSteps, currentStep}) {
  const state = useSelector(selectorQuiz)

  const shouldBeDisabled = useCallback((step) => {
    
    if (step <= 1) return false
    if (step >= 4) return true
    

    const questions = questionnaire.section3.questions

    let alreadyComplete = false
    for (const questionNumber in questions){
      if(!state[questionNumber] && !Array.isArray(state[questionNumber])){
        alreadyComplete = true
        break
      }
      if (Array.isArray(state[questionNumber]) && state[questionNumber].length <= 0){
        alreadyComplete = true
        break
      }
    }

    return alreadyComplete
  }, [state, questionnaire])

  const dots = []
  
  for (let i = 1; i <= totalSteps; i++) {
    const isActive = currentStep === i
    dots.push((
      <button
        type='button'
        key={`step-child-${i}`} 
        className={`dot ${isActive ? 'active' : ''}`}
        disabled={shouldBeDisabled(i)}
      >
        &bull;
      </button>
    ))
  }

  return (
    <nav className='nav'>{dots}</nav>
  )
}

export default memo(SubNavQuiz)